/* ==========================================================================
  main.js
========================================================================== */

"use strict";
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

/**
 * Init last realisations slider in front-page.php
 */

if (document.getElementById("realisations-slider")) {
  const homeRealisations = new Splide("#realisations-slider", {
    type: "fade",
    perMove: 1,
    pagination: false,
    arrows: true,
    890: {
      arrows: false
    },
  });

  function initThumbnail(thumbnail, index) {
    thumbnail.addEventListener("click", function () {
      homeRealisations.go(index);
    });
  }

  const thumbnails = document.getElementsByClassName(
    "home-realisations__items"
  );
  let current;

  for (var i = 0; i < thumbnails.length; i++) {
    initThumbnail(thumbnails[i], i);
  }

  homeRealisations.on("mounted move", function () {
    const thumbnail = thumbnails[homeRealisations.index];

    if (thumbnail) {
      if (current) {
        current.classList.remove("is-active");
      }

      thumbnail.classList.add("is-active");
      current = thumbnail;
    }
  });

  homeRealisations.mount();
}

/**
 * Sticky header on scroll
 */

window.addEventListener("scroll", function () {
  const mainHeader = document.querySelector(".site-header");
  const mainHeaderHeight = mainHeader.offsetHeight;
  const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  const triggerPosition = mainHeader.offsetTop + mainHeaderHeight;

  if (scrollPosition > triggerPosition) {
    mainHeader.classList.add("site-header--sticky");
    document.body.classList.add("has-header-sticky");
  } else {
    mainHeader.classList.remove("site-header--sticky");
    document.body.classList.remove("has-header-sticky");
  }
});
